import * as React from 'react';

import * as styles from './index.module.scss';

export interface ArticleSidebarListItemProps {
  children: React.ReactNode;
}

const ArticleSidebarListItem = ({children}: ArticleSidebarListItemProps) => (
  <li className={styles.sideBarListItem}>{children}</li>
);

export default ArticleSidebarListItem;
